module.exports = __webpack_public_path__ + "static/media/borrelli.9113a5ed.png";